import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { cloneDeep } from 'lodash-es';
import { exhaustMap } from 'rxjs';
import { BaseState, Drain, DrainRequest, RanneyWell } from '../../../model';
import { RanneyWellService } from '../../../services';

export function withDrainMethods() {
  return signalStoreFeature(
    { state: type<BaseState<RanneyWell>>() },
    withMethods(store => {
      const service = inject(RanneyWellService);
      const addDrain = rxMethod<{ id: number; data: DrainRequest }>(
        exhaustMap(({ id, data }) =>
          service.addDrain(id, data).pipe(
            tapResponse({
              next: rsp =>
                patchState(store, state => {
                  const active = cloneDeep(state.active);
                  if (active && active.id === id) {
                    if (active.drains) {
                      active.drains.push(rsp);
                    } else {
                      active.drains = [rsp];
                    }
                  }
                  return { active };
                }),
              error: console.log,
            })
          )
        )
      );
      const deleteDrain = rxMethod<{ id: number; drainId: number }>(
        exhaustMap(({ id, drainId }) =>
          service.deleteDrain(drainId).pipe(
            tapResponse({
              next: () =>
                patchState(store, state => {
                  const active = cloneDeep(state.active);
                  if (active && active.id === id) {
                    active.drains = active.drains.filter(drain => drain.id !== drainId);
                  }
                  return { active };
                }),
              error: console.log,
            })
          )
        )
      );
      const editDrain = rxMethod<{ drainId: number; data: DrainRequest }>(
        exhaustMap(({ drainId, data }) =>
          service.editDrain(drainId, data).pipe(
            tapResponse({
              next: rsp => updateActiveDrain(rsp),
              error: console.log,
            })
          )
        )
      );
      const updateActiveDrain = (data: Drain) =>
        patchState(store, state => {
          const active = cloneDeep(state.active);
          if (active && active.id === data.ranneyWellId) {
            const drainIdx = active.drains.findIndex(drain => drain.id === data.id);
            if (drainIdx !== undefined && drainIdx !== -1) {
              active.drains[drainIdx] = { ...data };
            }
          }
          return { active };
        });

      return { addDrain, editDrain, deleteDrain };
    })
  );
}
